/**
 * Runs `callback` inside the next user gesture (tap, click, or key press).
 *
 * iOS Safari only allows un-muted media playback when `.play()` is called
 * during a user gesture. When an autoplay attempt is rejected, register the
 * retry here so it re-runs with user activation the next time the child
 * touches the screen.
 *
 * Returns a cleanup function that removes the listeners (call it if the
 * component unmounts or the retry becomes irrelevant).
 */
export const onNextUserGesture = (callback: () => void): (() => void) => {
  const events: Array<keyof DocumentEventMap> = [
    "pointerdown",
    "touchend",
    "keydown",
  ];

  const handler = () => {
    cleanup();
    callback();
  };

  const cleanup = () => {
    events.forEach((event) =>
      document.removeEventListener(event, handler, true),
    );
  };

  events.forEach((event) =>
    document.addEventListener(event, handler, { capture: true, once: true }),
  );

  return cleanup;
};
